// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchQuery } from '@shared/data-access/queries';
import { SHARED_TAG_TYPES } from '../utils';
import { environment } from '@shared/environment';

export const copilotApi = createApi({
  baseQuery: fetchQuery({
    baseUrl: environment.API.COPILOT_BASE_URL!,
    headers: {
      'Content-Type': environment.API_CONSTANTS.HEADERS.CONTENT_TYPE,
      accept: environment.API_CONSTANTS.HEADERS.ACCEPT,
      Authorization: `Bearer ${environment.AI.API_BEARER_TOKEN}`,
    },
    authTokenUsage: false,
  }),
  endpoints: () => ({}),
  reducerPath: 'copilotApi',
  tagTypes: ['Chat', 'Portfolio', ...SHARED_TAG_TYPES],
});
